module.exports = __webpack_public_path__ + "static/pixelteh-f7935054989cc4ec61d7c32ace93fe7e.mp4";